import type { Column } from 'api/shared/models';
import { formats } from 'components/shared/ConfigurationTableModal/constants';

export const headerRows: Column[] = [
  {
    label: '',
    width: null,
    apiField: 'Checkbox',
    format: formats.TEXT,
    status: true,
  },
  {
    label: 'Descripci\u00F3n',
    width: null,
    apiField: 'description',
    format: formats.TEXT,
    status: true,
  },
  {
    label: 'Tipo de evento',
    width: '160px',
    apiField: 'eventType',
    format: formats.TEXT,
    status: true,
  },
  {
    label: '',
    width: '30px',
    apiField: 'viewed',
    format: formats.TEXT,
    status: true,
  },
];
